import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import VideoModalStore from '@src/business-components/video-modal/store';
import ModalContainer from '@src/components/modal-container';
import { noop } from '@src/utils/common-util';
import Link from '@src/components/link';

/**
 * VideoModal
 * @param store {VideoModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const VideoModal = ({ store, onClose = noop }) => {
  store.onClose = onClose;
  store.use();

  return (
    <ModalContainer modalState={store.showStatus}>
      <div className={cx(styles.root)}>
        <div className={styles.videoContainer}>
          <Link className={styles.closeBtn} onClick={onClose} />
          <video src={store.videoUrl} controls={true} autoPlay={true} loop={true} />
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(VideoModal, VideoModalStore);
